import React from 'react';
import { BattlePlayerStatusOption, BattlePlayerStatusType } from 'models/battles/BattlePlayerStatus';
import Status from './Status';
import Loader from '../../../commons/_/loader/Loader';
import { FormattedMessage } from 'react-intl';

export type SelectStatusProps = {
	onSelect: (option: BattlePlayerStatusOption) => void;
	isLoading: boolean;
};

const options = [
	{
		type: BattlePlayerStatusType.AVAILABLE,
		option: BattlePlayerStatusOption.AVAILABLE,
	},
	{
		type: BattlePlayerStatusType.TEMPORARY_NOT_AVAILABLE,
		option: BattlePlayerStatusOption.INACTIVE_FOR_24H,
	},
	{
		type: BattlePlayerStatusType.TEMPORARY_NOT_AVAILABLE,
		option: BattlePlayerStatusOption.INACTIVE_FOR_7D,
	},
	{
		type: BattlePlayerStatusType.NOT_AVAILABLE,
		option: BattlePlayerStatusOption.NOT_AVAILABLE,
	},
];

export const SelectStatus = ({ onSelect, isLoading }: SelectStatusProps) => {
	return (
		<div className="battlePlayerSelectMyStatus">
			<div className="battlePlayerSelectMyStatus__list ">
				{isLoading ? (
					<div className="d-flex justify-content-center">
						<Loader fixed={false} />
					</div>
				) : (
					options.map(item => (
						<div
							key={item.option}
							className="battlePlayerSelectMyStatus__list-element"
							onClick={event => {
								event.stopPropagation();
								onSelect(item.option);
							}}
						>
							<Status type={item.type}>
								<FormattedMessage id={`battles.status.option.${item.option}`} />
							</Status>
						</div>
					))
				)}
			</div>
		</div>
	);
};

export default SelectStatus;
